/**
 * Banking Domain Routes
 *
 * Route prefix: /:organisation/banking/
 *
 * Note: bank-transactions, bank-imports, and bank-statements routes are
 * nested as children of bank-accounts/:id to inherit the bank account ID
 */

import bankAccounts from './bank-accounts.js';
import bankRules from './bank-rules.js';

export default [
    ...bankAccounts,
    ...bankRules,
];
